/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnforcementSignalStatusEnum = 'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED';

export const EnforcementSignalStatusEnum = {

    QUEUED: 'QUEUED' as EnforcementSignalStatusEnum,

    IN_PROGRESS: 'IN_PROGRESS' as EnforcementSignalStatusEnum,

    DONE: 'DONE' as EnforcementSignalStatusEnum,

    FAILED: 'FAILED' as EnforcementSignalStatusEnum,

    CANCELING: 'CANCELING' as EnforcementSignalStatusEnum,

    CANCELED: 'CANCELED' as EnforcementSignalStatusEnum
};

